export const initButton = () => {
	const toggleFillOutlineClass = (attributes, addClass) => {
		if (!attributes || !attributes.className) {
			return addClass;
		}

		const oldClassName = attributes.className || "";

		if (!oldClassName) {
			return addClass;
		}

		let newClassName = oldClassName.replace(/is-style-(fill|outline)\s*/g, "").trim();

		if (addClass) {
			newClassName = `${addClass} ${newClassName}`.trim();
		}

		return newClassName;
	};

	const themePrimaryAttributes = (attributes) => {
		return {
			themeButtonStyle: "theme-primary",
			textColor: "white",
			backgroundColor: "orange-700",
			borderColor: "secondary",
			style: {
				...attributes.style,
				border: {
					width: "1px",
				},
				shadow: "var:preset|shadow|button-crisp-shadow",
				spacing: {
					padding: {
						top: "1.065em",
						bottom: "1.065em",
						left: "1.67em",
						right: "1.67em",
					},
				},
			},
			className: toggleFillOutlineClass(attributes, "is-style-outline"),
		};
	};

	const themeSecondaryAttributes = (attributes) => {
		return {
			themeButtonStyle: "theme-secondary",
			textColor: "secondary",
			backgroundColor: "white",
			borderColor: "secondary",
			style: {
				...attributes.style,
				border: {
					width: "1px",
				},
				shadow: "var:preset|shadow|button-crisp-shadow",
				spacing: {
					padding: {
						top: "1.065em",
						bottom: "1.065em",
						left: "1.67em",
						right: "1.67em",
					},
				},
			},
			className: toggleFillOutlineClass(attributes, "is-style-outline"),
		};
	};

	const defaultAttributes = (attributes) => {
		const oldClassName = attributes.className || "";

		return {
			themeButtonStyle: "default",
			textColor: undefined,
			backgroundColor: undefined,
			borderColor: undefined,
			style: undefined,
			className: toggleFillOutlineClass(attributes, ""),
		};
	};

	(function (wp) {
		const { addFilter } = wp.hooks;
		const { createElement, Fragment, useEffect } = wp.element;
		const { InspectorControls } = wp.blockEditor || wp.editor;
		const { PanelBody, SelectControl } = wp.components;

		// 1. Add new attribute to core/button block
		function addButtonStyleTypeAttribute(settings, name) {
			if (name !== "core/button") return settings;

			settings.attributes = {
				...settings.attributes,
				themeButtonStyle: {
					type: "string",
					default: "default",
				},
			};

			return settings;
		}
		addFilter("blocks.registerBlockType", "theme-btn/attribute", addButtonStyleTypeAttribute);

		function isStyleAlreadySet(attributes) {
			if (!attributes) {
				return false;
			}

			if (attributes.style) {
				return true;
			}

			if (attributes.themeButtonStyle) {
				return true;
			}

			if (attributes.textColor || attributes.backgroundColor) {
				return true;
			}

			if (attributes.className && attributes.className.includes("is-style-")) {
				return true;
			}

			if (attributes.fontSize || attributes.fontFamily) {
				return true;
			}

			return false;
		}

		// 2. Inject dropdown control into the Block Inspector
		function addButtonStyleTypeControl(BlockEdit) {
			return function (props) {
				if (props.name !== "core/button") return wp.element.createElement(BlockEdit, props);

				const { attributes, setAttributes } = props;
				const { themeButtonStyle } = attributes;

				// for enforcing the theme primary style
				// if (!isStyleAlreadySet(attributes)) {
				// 	setAttributes({
				// 		...themePrimaryAttributes(attributes),
				// 	});
				// }

				// for debugging purposes
				// useEffect(() => {
				// 	console.log("Button block attributes:", attributes);
				// }, [themeButtonStyle]);

				return wp.element.createElement(
					wp.element.Fragment,
					null,
					wp.element.createElement(BlockEdit, props),
					wp.element.createElement(
						wp.blockEditor.InspectorControls,
						null,
						wp.element.createElement(
							wp.components.PanelBody,
							{ title: "Button Style" },
							wp.element.createElement(wp.components.SelectControl, {
								label: "Style",
								value: themeButtonStyle,
								options: [
									{ label: "WordPress Default", value: "default" },
									{ label: "Theme Primary Button", value: "theme-primary" },
									{ label: "Theme Secondary Button", value: "theme-secondary" },
								],
								onChange: function (value) {
									setAttributes({ themeButtonStyle: value });
									switch (value) {
										case "theme-primary":
											setAttributes({
												...attributes,
												...themePrimaryAttributes(attributes),
											});
											break;
										case "theme-secondary":
											setAttributes({
												...attributes,
												...themeSecondaryAttributes(attributes),
											});
											break;
										default:
											setAttributes({
												...attributes,
												...defaultAttributes(attributes),
											});
									}
								},
							}),
						),
					),
				);
			};
		}

		addFilter("editor.BlockEdit", "theme-btn/controls", addButtonStyleTypeControl);

		// 3. Add class to saved output
		function applyButtonStyleTypeClass(extraProps, blockType, attributes) {
			if (blockType.name !== "core/button") return extraProps;

			if (attributes.themeButtonStyle === "theme-primary") {
				extraProps.className = (extraProps.className || "") + " theme-btn";
			}

			if (attributes.themeButtonStyle === "theme-secondary") {
				extraProps.className = (extraProps.className || "") + " theme-btn secondary";
			}

			return extraProps;
		}
		addFilter("blocks.getSaveContent.extraProps", "theme-btn/class", applyButtonStyleTypeClass);
	})(window.wp);
};
